import _ from "lodash";

export function parseValueName(name, mt) {
  const front = mt === "BROAD" || mt === "BROAD_PREFIX" ? "~" : "";
  const back = mt === "PREFIX" || mt === "BROAD_PREFIX" ? "*" : "";
  return `${front}${name}${back}`;
}

export function validateEmail(email) {
  var re = /\S+@\S+\.\S+/;
  return re.test(email);
}

export function searchIncludes(target, inputValue) {
  return target && _.toLower(target).includes(_.toLower(inputValue));
}

export function addChartBgSection(chart) {
  const xAxis = chart.xAxis[0];

  const startDate = new Date(xAxis.min);
  const endDate = new Date(xAxis.max);

  // Clear previous bg
  if (chart.customBg) {
    chart.customBg.forEach((bg) => bg.destroy());
  }
  chart.customBg = [];

  // Setup current to startDate of the week
  let current = new Date(startDate);
  const currentToSaturday = (current.getUTCDay() + 1) % 7;
  current.setUTCDate(current.getUTCDate() - currentToSaturday);
  let isGray = false;

  while (current < endDate) {
    if (isGray) {
      // From Sat. noon to next Sat. noon
      const startOfWeek = new Date(current);
      const daysToSaturday = (startOfWeek.getUTCDay() + 1) % 7;
      startOfWeek.setUTCDate(startOfWeek.getUTCDate() - daysToSaturday);
      startOfWeek.setUTCHours(12, 0, 0, 0);

      const endOfWeek = new Date(startOfWeek);
      endOfWeek.setUTCDate(endOfWeek.getUTCDate() + 7);

      let xMin = xAxis.toPixels(startOfWeek.getTime());
      let xMax = xAxis.toPixels(endOfWeek.getTime());

      // Avoid drawing outside plot
      xMin = Math.max(xMin, chart.plotLeft);
      xMax = Math.min(xMax, chart.plotLeft + chart.plotWidth);

      const rect = chart.renderer
        .rect(xMin, chart.plotTop, xMax - xMin, chart.plotHeight)
        .attr({
          fill: "#f2f2f2",
          zIndex: -1,
        })
        .add();
      chart.customBg.push(rect);
    }

    isGray = !isGray;
    current.setUTCDate(current.getUTCDate() + 7);
  }
}

export function transformCsvToArray(csv) {
  let string = _transformFn(csv);
  let items = _.split(string, ",");
  items = _.uniq(_.compact(items));
  return items;
}

export function getCurrencySymbol(currency = "USD") {
  const parts = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency,
  }).formatToParts(0);

  const symbolPart = parts.find((part) => part.type === "currency");
  return symbolPart ? symbolPart.value : "";
}

export function isSectionEmpty(section) {
  if (!section || _.isEmpty(section)) {
    return true;
  } else if (_.has(section, "includes") && _.has(section, "excludes")) {
    return _.isEmpty(section.includes) && _.isEmpty(section.excludes);
  } else if (_.has(section, "includes") && _.isEmpty(section.includes)) {
    return true;
  } else if (_.has(section, "excludes") && _.isEmpty(section.excludes)) {
    return true;
  } else {
    return false;
  }
}

function _transformFn(content) {
  const charArr = content.split("");
  let validContent = [];
  for (let c of charArr) {
    const lastC = _.last(validContent);
    switch (c) {
      case "\r": {
        continue;
      }

      case "\n":
      case " ": {
        // Ignore if we see continuous seperator
        if (lastC === undefined || lastC === ",") {
          continue;
        }

        c = ",";
        validContent.push(c);
        break;
      }

      default: {
        if (c >= "0" && c <= "9") {
          validContent.push(c);
        } else if (lastC && lastC !== ",") {
          validContent.push(",");
        }
        break;
      }
    }
  }

  return validContent.join("");
}
